export function getUrlParam(paramName) {
  return getAllQueryParams()[paramName];
}

export function getUrlPrefix() {
  return window.location.href.split('?')[0];
}
export function getAllQueryParams() {
  return window.location.search
    .substr(1)
    .split('&')
    .map(qp => qp.split('='))
    .filter(pair => pair[0] && pair[1])
    .reduce((aggr, pair) => Object.assign(aggr, { [pair[0]]: pair[1] }), {}) || {};
}

export function setNestedPropertyValue(obj, propString, value) {
  var schema = obj;  // a moving reference to internal objects within obj
    const pList = propString.split('.');
    var len = pList.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i];
      if (!schema[elem]) {
        schema[elem] = {};
      }
      schema = schema[elem];
    }
    schema[pList[len - 1]] = value;
}
